module.exports = __webpack_public_path__ + "img/starter.d8621029.jpg";